import { Card } from "@devhop/ui";
import type { ChecklistResultStatsResult } from "@/modules/checklist/domain/types/result";

type ChecklistResultChartsProps = {
  stats: ChecklistResultStatsResult;
};

export function ChecklistResultCharts({ stats }: ChecklistResultChartsProps) {
  const { total, completed, inProgress, cancelled } = stats.overall;
  if (total === 0) return null;

  const cPct = Math.round((completed / total) * 100);
  const pPct = Math.round((inProgress / total) * 100);
  const xPct = Math.round((cancelled / total) * 100);

  return (
    <Card className="gap-0 p-6">
      <h2 className="mb-4 font-semibold text-lg">ສັດສ່ວນສະຖານະການບັນທຶກ</h2>
      <div className="space-y-2">
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span>ສຳເລັດ</span>
            <span className="font-semibold">{cPct}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-green-500 transition-all"
              style={{ width: `${cPct}%` }}
            />
          </div>
        </div>
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span>ກຳລັງດຳເນີນຢູ່</span>
            <span className="font-semibold">{pPct}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-amber-500 transition-all"
              style={{ width: `${pPct}%` }}
            />
          </div>
        </div>
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span>ຍົກເລີກ</span>
            <span className="font-semibold">{xPct}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-muted-foreground/40 transition-all"
              style={{ width: `${xPct}%` }}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}
